import { useVisibleContainer } from "../hooks/useVisibleContainer";

// Route-effect component for "/profile". Renders nothing - ProfileScreen.tsx
// (mounted unconditionally in AppRoot) owns the actual rendering into
// #profileView, same pattern as every other Phase 10+ route screen
// (see GiftsRouteScreen.tsx).
export function ProfileRouteScreen() {
  useVisibleContainer("profileView");
  return null;
}
